/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtResponse } from '../../models/ot-response';

export interface GetOtMultiSitesGammes$Params {
  /**
   * id Ot pour lequel il faut récupérer les équipements energie.
   */
  idOt: string;
}

export function getOtMultiSitesGammes(
  http: HttpClient,
  rootUrl: string,
  params: GetOtMultiSitesGammes$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<OtResponse>>> {
  const rb = new RequestBuilder(rootUrl, getOtMultiSitesGammes.PATH, 'get');
  if (params) {
    rb.path('idOt', params.idOt, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OtResponse>>;
    })
  );
}

getOtMultiSitesGammes.PATH = '/v2/ots/{idOt}/multi_sites_gammes';
